import React, { useEffect, useState, useRef } from "react";

import { useGetStationsQuery, useGetStationSensorsQuery } from "../../services/smartsenseApi";
import { useForm } from "antd/lib/form/Form";
import axios from "axios";
import Header from "../Header";
import Footer from "../Footer";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from 'primereact/tooltip';
import { Calendar } from 'primereact/calendar';
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";


const getUserData = () => {
    const user = localStorage.getItem('userData');
    return user ? JSON.parse(user) : null;
};

function Sensors() {
    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const [experiences, setExperiences] = useState([]);
    const [loading, setLoading] = useState(false);
    const [stations, setStations] = useState([]);
    const [sensor, setSensor] = useState(null);
    const [thesensor, setThesensor] = useState(null);
    const [gender, setGender] = useState(null);
    const [sensors, setSensors] = useState(null);
    const [stationid, setStationid] = useState(0);
    const [theTemp, setTheTemp] = useState(null);
    const [currentTemp, setCurrentTemp] = useState(0);
    const [currentPres, setCurrentPres] = useState(0);
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(0);
    const [station, setStation] = useState(null);
    const [series, setSeries] = useState('');
    const [selectedsensor, setSelectedsensor] = useState(null);
    const [chartCategories, setChartCategories] = useState([]);
    const [chartSeriesData, setChartSeriesData] = useState([]);
    const [startDate, setStartDate] = useState(yesterday);
    const [endDate, setEndDate] = useState(today);
    const [reloadData, setReloadData] = useState(1);
    const userData = getUserData();
    const dt = useRef(null);

    const { data: _stations, isFetching: isFetchingStations, error: errorStations } = useGetStationsQuery(); //used
    // const { data: _sensors, isFetching: isFetchingSensors, error: errorSensors } = useGetStationSensorsQuery(stationid); //used

    useEffect(() => {
        if (!isFetchingStations) {
            setStations(_stations?.data);
        }
    }, [isFetchingStations]);


    useEffect(() => {
        if (!!stationid) {
            const params = {
                start_date: startDate,
                end_date: endDate
            };
            console.log(_stations);

            axios({
                method: 'get',
                url: process.env.REACT_APP_API_URL + '/web/stations/' + stationid + '/sensor-values',
                params: params
            })
            .then((response) => {
                var __sensors = [];

                var sensorData = response?.data?.data;
                let index = 0;
                let indexPres = -1;
                let indexTemp = -1;
                let indexHum = -1;
                sensorData.forEach(answer => {
                    let thesensor = {};
                    // answer.values.reverse();
                    thesensor.id = answer.id;
                    thesensor.name = answer.name;
                    answer.values = answer.values.map(obj => ({ ...obj, name: answer.name }))
                    thesensor.thedata = answer.values;
                    if(answer.name == "TC" || answer.name == "TEMP") 
                    {
                        indexTemp = index;
                    }
                    if(answer.name == "HUM" || answer.name == "RH") 
                    {
                        indexHum = index;
                    }
                    if(answer.name == "PRES") 
                    {
                        indexPres = index;
                    }
                    __sensors.push(thesensor);
                    index++;
                })

                if((indexTemp != -1) && (indexHum != -1) && __sensors[indexTemp].thedata.length)
                {
                    setMax(Math.max(...__sensors[indexTemp].thedata.map(o => o.value)).toFixed(0));
                    setMin(Math.min(...__sensors[indexTemp].thedata.map(o => o.value)).toFixed(0));
                    doCalculus(__sensors[indexHum].thedata[0].value, __sensors[indexTemp].thedata[0].value);
                    setCurrentTemp(parseFloat(__sensors[indexTemp].thedata[0].value).toFixed(0));
                }
                if((indexPres != -1) && __sensors[indexPres].thedata.length)
                {
                    setCurrentPres(parseFloat(__sensors[indexPres].thedata[0].value).toFixed(0));
                }
                setSensors(__sensors);
                setLoading(false);

            }, (error) => {
                console.log(error);
            });
        }

    }, [stationid, reloadData]);

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    }

    const sensorTemplate = (rowData) => {
        return rowData.sensor.name;
    }

    const doCalculus = (airHum, airTemp) => {
        let prag = [0, 1];
        let raport = 0;
        let returnTemp = 0;
        let step_l = 0.01;
        let step_h = 0.02;
        let fl43 = 1.15;
        let fh43 = 1.66;
        let fl22 = 1;
        let fh22 = 1.390;
        let praguri = [];
        praguri['22'] = [22, 31];
        praguri['23'] = [23, 33];
        praguri['24'] = [24, 35];
        praguri['25'] = [25, 37];
        praguri['26'] = [26, 39];
        praguri['27'] = [27, 41];
        praguri['28'] = [28, 43];
        praguri['29'] = [29, 46];
        praguri['30'] = [30, 48];
        praguri['31'] = [32, 50];
        praguri['32'] = [33, 53];
        praguri['33'] = [34, 55];
        praguri['34'] = [36, 58];
        praguri['35'] = [37, 61];
        praguri['36'] = [39, 63];
        praguri['37'] = [40, 66];
        praguri['38'] = [42, 69];
        praguri['39'] = [43, 72];
        praguri['40'] = [45, 75];
        praguri['41'] = [46, 79];
        praguri['42'] = [48, 82];

        if (airHum >= 25) {
            if (airTemp >= 22 && airTemp <= 42) {
                prag = praguri[Math.floor(airTemp)];
            }
            else if (airTemp >= 43) {
                fl43 += step_l * (airTemp - 42);
                const low = airTemp * fl43;
                fh43 += step_h * (airTemp - 42);
                const high = low * fh43;
                prag = [low, high];
            }
            else if (airTemp < 22) {
                const low = airTemp * fl22;
                fh22 -= step_h * (22 - airTemp);
                const high = low * fh22;
                prag = [low, high];
            }
            raport = (prag[1] - prag[0]) / (100 - 25);
            returnTemp = prag[1] - raport * (100 - airHum);
        }

        setTheTemp(returnTemp.toFixed(0));
    }

    const doChart = (data) => {
        let _chartCategories = [];
        let _chartSeriesData = [];

        data.thedata.map((chartdata, i) => {
            _chartCategories.push(chartdata.date);
            _chartSeriesData.push(chartdata.value);
        })

        setSeries(data.name);
        setChartCategories(_chartCategories);
        setChartSeriesData(_chartSeriesData);
    }

    const timeout = (delay, value) => {
        setLoading(true);

        const timer = setTimeout(() => {
            setThesensor(value);
            setSensor(value);
            doChart(value);
            setLoading(false);
        }, 2000);

        return () => {
            clearTimeout(timer);
        }
    }

    const header = (
        <div className="hiddenmobile col-12 align-items-center export-buttons" style={{ height: "51px" }}>
            <div className="col-md-8 col-sm-12" style={{ lineHeight: "51px" }}>Descarca datele senzorului</div>
            <Button type="button" value="Selectia curenta" icon="pi pi-filter" onClick={() => exportCSV(true)} className="p-button-info float-right" data-pr-tooltip="Selectia curenta" />
            <Button type="button" value="Toate datele" icon="pi pi-file" style={{ marginRight: "10px" }} onClick={() => exportCSV(false)} className="float-right mr-10" data-pr-tooltip="Tot tabelul" />
        </div>
    );

    const chartoptions = {
        chart: {
            id: "basic-bar",
        },
        xaxis: {
            categories: chartCategories
        }
    };

    const chartseries = [
        {
            name: series,
            data: chartSeriesData
        }
    ]
    return (
        <>
            {loading && <div style={{ position: "absolute", width: "100%", height: "100%", background: "rgba(0,0,0,0.6)", zIndex: "99" }}>
                <div className="p-datatable-loading-overlay p-component-overlay"><i className="p-datatable-loading-icon pi-spin pi pi-spinner superCenter" style={{ color: "#fff", fontSize: "50px" }}></i></div>
            </div>}

            <div className="bg-[rgb(239,243,248)] min-h-full pb-1">
                <Header />
                <div className="max-w-7xl p-10 box-border py-8 mx-auto my-10 bg-white rounded-lg">
                    <div className="row">
                        <div className="col-md-4 field mb-6">
                            <h1 className="mb-0 mt-1 text-2xl">Pasul 1: Selecteaza statia</h1>
                        </div>
                        <div className="col-md-8 field">
                            <span className="p-float-label">
                                <Dropdown
                                    id="status"
                                    name="status"
                                    value={station}
                                    onChange={(event) => {
                                        setLoading(true);
                                        setStationid(event.value.id)
                                        setStation(event.value);
                                        setSensor(null);
                                        setThesensor(null);
                                        setTheTemp(null);
                                    }}
                                    options={stations}
                                    optionLabel="name"
                                    className="col-12"
                                />
                            </span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 field mb-6">
                            <h1 className="mb-0 mt-1 text-2xl"><small style={{ color: "rgb(185,178,178)" }}>(Optional)</small> Filtreaza dupa data</h1>
                        </div>
                        <div className="col-md-8 field mb-2">
                            <div className="px-0 mb-2 col-md-5 col-sm-12">
                                <Calendar dateFormat="yy-mm-dd" className="col-12 pr-2" value={startDate} onChange={(e) => setStartDate(e.value)}></Calendar>
                            </div>
                            <div className="px-0 mb-2 col-md-5 col-sm-12">
                                <Calendar dateFormat="yy-mm-dd" className="col-12 pr-2" value={endDate} onChange={(e) => setEndDate(e.value)}></Calendar>
                            </div>
                            <div className="px-0 mb-4 col-md-2 col-sm-12">
                                <Button type="button" value="Filtreaza" className="float-right col-12" data-pr-tooltip="Filtreaza"
                                    onClick={(event) => {
                                        setLoading(true);
                                        setChartCategories([]);
                                        setChartSeriesData([]);
                                        setReloadData(reloadData + 1);
                                        setThesensor(null);
                                        setSensor(null);
                                        // timeout(1000, sensor);
                                    }}
                                >Filtreaza</Button>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {sensors &&
                            <div className="col-md-4 field mb-6 pr-10">
                                {theTemp && 
                                    <div className="hiddenmobile col-12 mb-6">
                                        <h2>Date curente</h2>
                                        <div className="col-12 row">
                                            <div className="col-6">
                                                <p>Temperatura maxima</p>
                                            </div>
                                            <div className="col-6">
                                                {max}
                                            </div>
                                        </div>
                                        <div className="col-12 row">
                                            <div className="col-6">
                                                <p>Temperatura minima</p>
                                            </div>
                                            <div className="col-6">
                                                {min}
                                            </div>
                                        </div>
                                        <div className="col-12 row">
                                            <div className="col-6">
                                                <p>Temperatura curenta</p>
                                            </div>
                                            <div className="col-6">
                                                {currentTemp}
                                            </div>
                                        </div>
                                        <div className="col-12 row">
                                            <div className="col-6">
                                                <p>Presiune curenta</p>
                                            </div>
                                            <div className="col-6">
                                                {currentPres}
                                            </div>
                                        </div>
                                        <div className="col-12 row">
                                            <div className="col-6">
                                                <p>Temperatura resimtita</p>
                                            </div>
                                            <div className="col-6">
                                                {theTemp}
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="col-12field mb-6">
                                    <div className="col-12 field mb-6">
                                        <h1 className="mb-0 mt-1 text-2xl">Pasul 2: Selecteaza senzorul</h1>
                                    </div>
                                    <div className="col-12 field">
                                        <span className="p-float-label">

                                            <Dropdown
                                                id="status"
                                                name="status"
                                                value={sensor}
                                                placeholder="Sensor"
                                                onChange={(event) => {
                                                    timeout(1000, event.value);
                                                }}
                                                optionLabel="name"
                                                options={sensors}
                                                className="col-12"
                                                disabled={loading}
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>}
                        {thesensor && <>
                            <div className="col-md-8 field mb-6">
                                <Chart
                                    options={chartoptions}
                                    series={chartseries}
                                    type="line"
                                    className="col-12"
                                    height="300"
                                />
                                <DataTable ref={dt} value={thesensor.thedata} header={header} paginator responsiveLayout="stack"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}>
                                    <Column header="Tip senzor" field="name"></Column>
                                    <Column header="Data" field="date"></Column>
                                    <Column align="right" header="Valoare" field="value"></Column>
                                </DataTable>
                                <Tooltip target=".export-buttons>button" position="bottom" />
                            </div>
                        </>}
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default Sensors;
